import React from 'react'
import { useQuery } from "@apollo/client"
import { get } from 'lodash'

import AppFrame from '../AppFrame'
import { QUERY_ORDER_CONTACTS_DATA } from '../data/services/graphqlQueries'
import { map } from 'lodash'
import { generateAddress } from '../helpers/clinic'
import EcsButton from '../components/Button'
import PageHeader from '../components/PageHeader'
import ClinicCard from '../components/ClinicCard'

export default ({globalData, clinic}) => {
  const { loading, error, data } = useQuery(QUERY_ORDER_CONTACTS_DATA, {
    notifyOnNetworkStatusChange: true
  })

  if (loading) return null

  const orderContactsPageData = get(data,'pageData[0]')
  const clinics = get(data,'clinics')

  const cardCallback = (c) => {
    window.open(c.buyContactsUrl, '_blank');
  }

  return (
    <AppFrame data={globalData}>
      <div className="max-w-6xl mx-auto px-4 pb-8 pt-12 min-h-[400px]">
        
        <PageHeader title={'Order Contacts'} />
          
        <div dangerouslySetInnerHTML={{__html: orderContactsPageData ? orderContactsPageData.body : ''}} className="mt-12 mb-8"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {
            map(clinics, (c, index) => {
              if (!c.buyContactsUrl) return null

              return <ClinicCard 
                globalData={globalData} 
                clinic={c}
                key={`order-contacts-card-${index}`} 
                callback={cardCallback}
                cta="order contacts"
              />
            })
          }
        </div>
      </div>
    </AppFrame>
  )
}